const ConsoleHelper = (...args: any) => {
    if (process.env.NODE_ENV === 'development') {
        for(const argument of args){
            console.log(argument)
        }
    } 
    return
  }
  
  export default ConsoleHelper;